import { queryOptions, skipToken } from "@tanstack/react-query";

import { MASTER_INVALIDATION_KEY } from "@/api/queryClient";
import { getWorkspaceProfileFile } from "@/api/resources/workspaceProfileFiles/api";
import i18n from "@/providers/i18n";

const entities = i18n.t("files");
const entitiesErrorMessage = {
  text: i18n.t("notify.error-reason.unexpected"),
  title: i18n.t("notify.get.error", { e: entities }),
};

export const workspaceProfileFilesQueryKeys = {
  all: () => [...MASTER_INVALIDATION_KEY, "workspaceProfileFiles"],
  byId: (workspace_id?: string) => [...workspaceProfileFilesQueryKeys.all(), "byId", workspace_id],
};

export const workspaceProfileFilesQueries = {
  byId: (workspace_id?: string) =>
    queryOptions({
      queryKey: [...workspaceProfileFilesQueryKeys.byId(workspace_id)],
      queryFn: workspace_id ? () => getWorkspaceProfileFile({ match: { workspace_id } }) : skipToken,

      meta: {
        errorMessage: entitiesErrorMessage,
      },
    }),
};
